import './DetailsOption.css'

interface Props
{
    title: String|undefined
	description: String|undefined
    imageSrc: String|undefined
}

const DetailsOption = (props: Props) =>
{
	return (
        <div className="details-option-main-container" >
            <img className='details-option-image' src={`${props.imageSrc}`} alt='title-image'></img>
            <div className="details-option-column">
                <div className='details-option-title'> {props.title} </div>
                <div className='details-option-description'> {props.description} </div>
            </div>
            
        </div>
	)
}

export default DetailsOption
